// @flow
import React from "react";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TeamLogo from "../../components/TeamLogo";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import formatDates from "../../common/formatDates";
import type { Game, Opponent, Team } from "../../common/types";
import { useHistory } from "react-router-dom";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Skeleton from "@material-ui/lab/Skeleton";

type Props = {
  leftTeam: Team | Opponent,
  rightTeam: Team | Opponent,
  game: Game,
};

function TicketReservationHeader({ leftTeam, rightTeam, game }: Props) {
  const history = useHistory();
  if (leftTeam == null || rightTeam == null || game == null) {
    return <Skeleton width="100%" height={30} />;
  }
  return (
    <Box mb={3}>
      <AppBar color="inherit">
        <Toolbar>
          <Grid
            container
            justify="space-between"
            alignItems="center"
            wrap="nowrap"
          >
            <Grid
              item
              container
              wrap="nowrap"
              alignItems="center"
              justify="flex-start"
            >
              <div>
                <TeamLogo
                  width={24}
                  height={24}
                  iconString={leftTeam.iconString}
                  name={leftTeam.name}
                />
              </div>

              <Typography variant="caption" color="textSecondary">
                vs&nbsp;
              </Typography>
              <div>
                <TeamLogo
                  width={24}
                  height={24}
                  iconString={rightTeam.iconString}
                  name={rightTeam.name}
                />
              </div>
              <Box ml={2}>
                <Typography variant="body2" color="textSecondary">
                  {formatDates.dayAndDate(game.date)} -{" "}
                  {formatDates.time(game.date)} Uhr
                </Typography>
              </Box>
            </Grid>
            <Grid item>
              <Button onClick={history.goBack}>Abbrechen</Button>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      <Toolbar style={{ marginTop: "env(safe-area-inset-top)" }} />
    </Box>
  );
}

export default TicketReservationHeader;
